import type { ReactNode } from 'react';

export const symbol_sports_martial_arts: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M510-464 491-69q-1 12-10 20.5T458-40q-12 0-20.5-8.5T428-69l-18-357-163-94-19 68 63 111q6 11 3.5 22.5T281-301q-11 6-23 3t-18-14l-71-120q-3-5-4-11t1-12l43-152 237-137-91-91q-9-9-9-21t9-21q9-9 21-9t21 9l119 118q11 11 9 25.5T510-711l-111 63 85 69 299-266q8-7 19-6.5t20 9.5q8 8 8.5 18.5T823-805L510-464ZM193-677q-30 0-51.5-21.5T120-750q0-30 21.5-51.5T193-823q30 0 51.5 21.5T266-750q0 30-21.5 51.5T193-677Z"
		/>
	</svg>
);
